<div class="spinner-wrap" [class.overlay]="overlay">
  <div class="ring"></div>
  <span class="label" *ngIf="label">{{ label }}</span>
</div>
